/**
 * Write-only sentinel asking the database to stamp the field with the server's
 * clock at commit time — the Firebase-free stand-in for Firestore's
 * `serverTimestamp()`. Use it inline in a write; it is never read back, since
 * reads always yield a concrete `Date`.
 */
export const JC_SERVER_TIMESTAMP: unique symbol = Symbol('JcServerTimestamp');

/** The type of the {@link JC_SERVER_TIMESTAMP} sentinel. */
export type JcServerTimestamp = typeof JC_SERVER_TIMESTAMP;
